import { type DataBlockArrayCreator } from './SHURDataBlockCreator'
import type { DataBlock } from 'de-zurich-ui-library'

export class SHUREmptyDataCreator implements DataBlockArrayCreator {
  createDatablockArray(): DataBlock[] {
    return []
  }
}

// when no details are provided
export function fallbackNoDetailsAvailableDataSection(): DataBlock {
  return {
    title: {
      label: 'noDetailsAvailable'
    },
    data: []
  }
}
